module.exports = __webpack_public_path__ + "media/images/emblems/Aeschi-blason-5c09e5fbe7065ed9cc8fc0b6395f58e4.png";